import {cva} from 'class-variance-authority'

/**
 * Typography variants.
 *
 * Two scales coexist during the v3 migration:
 * - `variant` — the new MUI type scale (h1–h6, subtitle1/2, body1/2, bodyLarge,
 *   caption, overline). Headings are responsive: a smaller size at the base
 *   breakpoint, switching to the desktop size at `md:`. Each variant bakes in its
 *   own font-weight, line-height and letter-spacing.
 * - `size` — the legacy GoTu scale (kept so existing components keep compiling
 *   until they migrate). Deprecated.
 */
export const TypographyVariantsFactory = cva('font-sans', {
  variants: {
    // --- New MUI scale (responsive headings; mobile sizes provisional) ---
    variant: {
      h1: 'font-light text-[2.5rem] leading-[1.167] tracking-[-1.5px] md:text-[4.5rem]',
      h2: 'font-light text-[2.125rem] leading-[1.2] tracking-[-0.5px] md:text-[3.75rem]',
      h3: 'font-light text-[1.875rem] leading-[1.167] md:text-[3rem]',
      h4: 'font-light text-[1.625rem] leading-[1.235] tracking-[0.25px] md:text-[2.5rem]',
      h5: 'font-light text-[1.5rem] leading-[1.334] md:text-[2rem]',
      h6: 'font-light text-[1.375rem] leading-[1.6] tracking-[0.15px] md:text-[1.5rem]',
      subtitle1: 'font-bold text-[1rem] leading-[1.75] tracking-[0.15px]',
      subtitle2: 'font-bold text-[0.875rem] leading-[1.57] tracking-[0.1px]',
      body1: 'font-normal text-[1rem] leading-[1.2] tracking-[0.15px]',
      body2: 'font-normal text-[0.875rem] leading-[1.43] tracking-[0.17px]',
      bodyLarge: 'font-normal text-[1.25rem] leading-[1.5] tracking-[0.15px]',
      caption: 'font-normal text-[0.75rem] leading-[1.66] tracking-[0.4px]',
      overline: 'font-normal text-[0.75rem] leading-[1] tracking-[1px] uppercase',
    },
    // --- Legacy GoTu scale (deprecated) ---
    size: {
      heading_1: 'text-heading-1', // 48px web
      heading_2: 'text-heading-2', // 32px web
      heading_3: 'text-heading-3', // 24px web
      heading_4: 'text-heading-4', // 20px web
      body_large: 'text-body-large', // 16px — both
      body_large_tight: 'text-body-large-tight', // 16px / 120% lh — web
      body_small: 'text-body-small', // 15px — both
      caption: 'text-caption', // 14px — both
      caption_sm: 'text-caption-sm', // 13px — both
      label: 'text-label', // 12px — both
    },
    // `bold`/`italic`/`uppercase` are overrides layered on top of the scale.
    // `false` emits nothing so it never fights a variant's intrinsic weight.
    bold: {
      true: 'font-bold',
      false: '',
    },
    italic: {
      true: 'italic',
      false: '',
    },
    uppercase: {
      true: 'uppercase',
      false: '',
    },
    textAlign: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
      justify: 'text-justify',
    },
  },
  defaultVariants: {
    bold: false,
    italic: false,
    uppercase: false,
  },
})
